"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesList = CompaniesList;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const icons_1 = require("@ant-design/icons");
const debounce_1 = __importDefault(require("lodash/debounce"));
const elements_1 = require("@src/components/elements");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const react_intl_1 = require("react-intl");
const CompaniesListGrid_1 = require("@src/components/modules/global/CompaniesList/CompaniesListGrid");
const CompaniesList_style_1 = require("./CompaniesList.style");
function CompaniesList() {
    const [search, setSearch] = react_1.default.useState('');
    const [page, setPage] = react_1.default.useState(1);
    const history = (0, react_router_1.useHistory)();
    const { data: companies, isLoading } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.companiesList.key, { search, page }, [search, page]);
    const isCompanyListNotEmpty = Boolean(companies && companies.data && companies.data.length);
    react_1.default.useEffect(() => {
        setPage(1);
    }, [search]);
    const intl = (0, react_intl_1.useIntl)();
    const onPaginationChange = (actualPage) => {
        const params = new URLSearchParams();
        if (actualPage !== 1) {
            params.append('page', actualPage.toString());
            history.push({ search: params.toString() });
        }
        else {
            // @ts-ignore
            history.pushLocalized(`/zoznam-zamestnavatelov`);
        }
        setPage(actualPage);
    };
    const onChangeSearch = (searchValue) => {
        if (!searchValue || searchValue.trim()) {
            setSearch(searchValue);
        }
    };
    const debouncedSearch = (0, debounce_1.default)(onChangeSearch, 300);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(CompaniesList_style_1.Hero, { className: "flex-col align-center", children: [(0, jsx_runtime_1.jsx)("h1", { className: "m-t-l m-b-l", children: intl.formatMessage({ id: 'companies_list' }) }), (0, jsx_runtime_1.jsx)(CompaniesList_style_1.InputBlock, { children: (0, jsx_runtime_1.jsx)(elements_1.Input, { prefix: isLoading && search ? (0, jsx_runtime_1.jsx)(elements_1.Spinner, { delay: 0 }) : (0, jsx_runtime_1.jsx)(icons_1.SearchOutlined, {}), placeholder: intl.formatMessage({ id: 'companies_list.filter_by_name' }), className: "m-b-l", onChange: e => debouncedSearch(e.target.value) }) })] }), (0, jsx_runtime_1.jsxs)(CompaniesList_style_1.MainContent, { children: [(0, jsx_runtime_1.jsx)(elements_1.Pagination, { className: "m-t-l", current: page, onChange: onPaginationChange, total: companies === null || companies === void 0 ? void 0 : companies.total, showSizeChanger: false }), (0, jsx_runtime_1.jsxs)(elements_1.Holder, { children: [(0, jsx_runtime_1.jsx)(CompaniesListGrid_1.CompaniesListGrid, { companies: (companies === null || companies === void 0 ? void 0 : companies.data) || [], isLoading: isLoading }), isCompanyListNotEmpty && ((0, jsx_runtime_1.jsx)(elements_1.Pagination, { className: "m-b-m", current: page, onChange: onPaginationChange, total: companies === null || companies === void 0 ? void 0 : companies.total, showSizeChanger: false }))] })] })] }));
}
